import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import WireMatchHeader from '../common/wire-match-header';
import Wire from '../common/wire';
import useGetSearchWiresSimilar from '../../../services/wires/similar-service';
import WireResultsContext from './context';
import useScrollableWires from '../common/scrollable-wires-hooks';
import Tail from '../common/wires-list-tail';
import NoSimilar from './no-similar';

export default function SimilarTo({ query, exclude, searchUpdateEnabled }) {
  const { dispatch } = React.useContext(WireResultsContext);
  const {
    loading, infiniteRef, wires, rawData, expandList, total, showExpand, hasMore,
  } = useScrollableWires({
    isScrollable: false,
    initNumber: searchUpdateEnabled ? 20 : 2,
    useGetWires: () => useGetSearchWiresSimilar(query, exclude),
  });

  React.useEffect(() => {
    dispatch({
      type: 'setLoadingSimilar',
      // eslint-disable-next-line no-nested-ternary
      payload: !loading ? null : (wires.length ? 'more' : 'init'),
    });
  }, [loading, dispatch, wires.length]);

  React.useEffect(() => {
    if (_.get(rawData, 'wires.length')) {
      dispatch({ type: 'setSimilarWires', payload: rawData.wires });
    }
  }, [rawData, dispatch]);

  return (
    <>
      <article>
        <WireMatchHeader query={query} text="similar to" n={total} />
        {wires.map((wire, index) => <Wire bordered={false} key={`similar-wire-${wire.id}`} wire={wire} position={index + 1} />)}
        <div ref={infiniteRef} />
        {!!showExpand && (
          <Tail><button type="button" onClick={expandList}>see all results</button></Tail>
        )}
        {!hasMore && <Tail><span>You have seen all the results</span></Tail>}
        {!wires.length && (<NoSimilar query={query} />)}
      </article>
    </>
  );
}

SimilarTo.propTypes = {
  query: PropTypes.string.isRequired,
  exclude: PropTypes.arrayOf(PropTypes.number).isRequired,
  searchUpdateEnabled: PropTypes.bool.isRequired,
};
